/**How the API rejects an order-line save: a list of field errors with every value wrapped in an
 * array. Only `code` is meant to be read by us.*/
export interface IReturnPackagingApiError {
  code?: string[];
  detail?: string[];
  type?: string[];
  status?: string[];
}

/**The message shown when the failure carries no code we recognize.*/
export const RETURN_PACKAGING_SAVING_ERROR_KEY = 'orderProcess.returnPackaging.savingError';

const ERROR_TRANSLATION_KEYS: { [code: string]: string } = {
  RETURN_DAY_UNAVAILABLE: 'orderProcess.returnPackaging.errors.returnDayUnavailable',
};

/**Takes the raw rejection — an HttpErrorResponse, or anything else that reached the catch.*/
export function getReturnPackagingErrorKey(error: unknown): string {
  return ERROR_TRANSLATION_KEYS[_getErrorCode(error)] || RETURN_PACKAGING_SAVING_ERROR_KEY;
}

/**Reads the first code out of the rejection body. The body is normally the array above, but a
 * single error object is accepted too, and everything else yields no code at all.*/
function _getErrorCode(error: unknown): string {
  const body = (error as { error?: unknown })?.error;

  if (!body || typeof body !== 'object') {
    return '';
  }

  const [first] = (Array.isArray(body) ? body : [body]) as IReturnPackagingApiError[];
  const [code] = (first?.code) || [];

  return code || '';
}
